import { selectRegister, setRegisterLock } from './register';
import { getRegisterState } from './utils';
import { updateRegisterUI } from './view';

export function onPageLoad(
  selectedRegisterID: string,
  isRegisterLocked: boolean,
  canLockRegister: boolean
) {
  updateRegisterUI(selectedRegisterID, isRegisterLocked, canLockRegister);
}

export function onSelectRegister(event: MouseEvent) {
  event.preventDefault();
  event.stopImmediatePropagation();
  const target = event.currentTarget as HTMLButtonElement;

  // Target is disabled or non existent, stop processing
  if (target?.disabled ?? false) {
    return;
  }

  const { registerID, registerName, status } = getRegisterState(target);

  // Prevent spamming
  target.disabled = true;

  selectRegister(registerID, registerName, status).then(() => {
    // Reload the sales/register page if its already loaded
    window.merchantos.tabs.tabs.register?.reload(false);
  });
}

export function onLockRegister(event: InputEvent) {
  event.preventDefault();
  event.stopImmediatePropagation();

  // Save currentTarget aside as its reference withing event might change next tick
  const target = event.currentTarget as HTMLInputElement;

  if (target.disabled) {
    return;
  }

  const { registerID } = getRegisterState(target);

  target.disabled = true;
  setRegisterLock(registerID, target.checked).then(() => {
    target.disabled = false;
  });
}
